<template>
  <div class="footer-toolbar">
    <div
      size="small"
      class="footer-toolbar-form"
    >
      <!-- :inline="true" -->
      <div class="footer-toolbar-left">
        <!-- 使用mk无法solt 全选该页 -->
        <el-checkbox
          v-model="checked"
          @change="handleOnSelectChange"
        >
          全选该页
        </el-checkbox>
      </div>
      <div class="footer-toolbar-right">
        <div class="mr-30">
          <mk-button-biz
            type="text"
            height="32px"
            class="footer-toolbar-button"
            @click="handleOnApplyClick"
          >
            <ds-iconfont icon-class="iconbiaoqianshezhi"></ds-iconfont>
            <span class="footer-toolbar-text">编辑标签</span>
          </mk-button-biz>
        </div>
        <div class="mr-30">
          <mk-button-biz
            type="text"
            height="32px"
            class="footer-toolbar-button"
            @click="handleOnRemoveClick"
          >
            <ds-iconfont icon-class="icon-mk-shanchu1"></ds-iconfont>
            <span class="footer-toolbar-text">删除</span>
          </mk-button-biz>
        </div>
        <div class="footer-toolbar-total">
          <span>
            共选择
            <span class="footer-toolbar-page">{{ selection.length }}</span>项
          </span>
          <!-- <mk-button
            type="text"
            class="footer-toolbar__cancel"
          >
            取消
          </mk-button>-->
          <span
            class="footer-toolbar-cancel cursor"
            @click="handleOnCancelClick"
          >取消</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterToolbar',
  props: {
    // 是否全选
    selectAll: {
      type: Boolean,
      default: false
    },
    // 当前选中时的数数组
    selection: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      checked: this.selectAll
    }
  },
  watch: {
    selectAll () {
      this.checked = this.selectAll
    }
  },
  methods: {
    // 全选
    handleOnSelectChange (value) {
      this.$emit('on-checked-change', value)
    },
    // 取消
    handleOnCancelClick () {
      this.$emit('on-cancel-click')
    },
    // 删除
    handleOnRemoveClick () {
      this.$emit('on-remove-click')
    },
    // 批量打标签
    handleOnApplyClick () {
      this.$emit('on-apply-click')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-toolbar {
  position: relative;
  z-index: 1;
  height: 50px;
  box-shadow: 0 -1px 4px 0 rgba(0, 0, 0, 0.15);

  .footer-toolbar-form {
    height: 50px;
    line-height: 50px;
    padding: 0 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .footer-toolbar-right {
      display: flex;
      align-items: center;

      .mr-30 {
        margin-right: 30px;
      }

      .footer-toolbar-button {
        color: #666;

        .footer-toolbar-text {
          margin-left: 5px;
        }
      }

      .footer-toolbar-button:hover {
        color: #009cff;
      }

      .footer-toolbar-total {
        color: #262626;
        font-size: 14px;

        .footer-toolbar-page {
          display: inline-block;
          margin: 0 3px;
          color: #009cff;
        }
      }

      .footer-toolbar-cancel {
        font-size: 14px;
        display: inline-block;
        margin-left: 15px;
        color: #009cff;
      }
    }
  }
}
</style>
